<template>
    <el-table
      :data="dataList"
      border
      style="width: 100%"
    >
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="50"
        label="行号"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="产品名称"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="color"
        label="颜色"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="size"
        label="规格"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="attr1"
        label="幅宽"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="attr2"
        label="克重"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="count"
        label="预计量"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="checkInCount"
        label="收货量"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="useCount"
        label="已用量"
        header-align="center"
        align="center"
      ></el-table-column>
    </el-table>
</template>

<script>
export default {
  components: {},
  props: {
    dataList: {
      type: Array,
      default: ()=>{
        return []
      },
    },
  },
  data() {
    return {

    };
  },
  watch: {

  },
  methods: {

  },
};
</script>
